const Technology = require("../../../entities/Technology");
const {TechnologyNames, TechnologyTypes, Age}  = require("../../Constants");

class Artillery extends Technology {
    constructor(age, techName, scienceCost, workerCost, multiplier){
        super(
            age,
            Artillery.GetType(),
            techName,
            scienceCost,
            workerCost,
            {
                playerStateAltering:
                (playerState) => playerState.militaryCalculationDelegate.push({
                    Source: this,
                    Action: () => this.GetWorkerCount() * multiplier,
                })
            }
        )
        // Strength of one unit (e.g. what sacrificing it is worth when colonizing)
        this.multiplier = multiplier;
    }

    static GetType = () => TechnologyTypes.Military.Artillery;
}

class Cannon extends Artillery {
    constructor(){
        super(Cannon.GetAge(), Cannon.GetName(), 6, 5, 3)
    }

    static GetInstance = () => new Cannon();
    static GetAge = () => Age.Age2;
    static GetName = () => TechnologyNames.Military.Cannon;
}

class Rockets extends Artillery {
    constructor(){
        super(Rockets.GetAge(), Rockets.GetName(), 8, 7, 5)
    }

    static GetInstance = () => new Rockets();
    static GetAge = () => Age.Age3;
    static GetName = () => TechnologyNames.Military.Rockets;
}

module.exports = {
    Cannon,
    Rockets
}